import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  hmgmainGetHmgMain,
  rolesGet,
  rolesGetMappedtoHMG,
  hmgRoleUpdate,
} from "../../store/actions/index";
import HmgRoleMapping from "../../components/RoleManager/HMGRoleMapping/HmgRoleMapping";
import { HmgMainDropdown } from "../../components/HmgHotelDropdown";
import { Modal, message } from "antd";

const { confirm } = Modal;

const initialConfigs = {
  hmgmainSelect: undefined,
  hmgmainList: [],
  roleData: [],
  initialValue: [],
  mappedRoles: [],
  inactiveSubmit: true,
};

const showConfirm = (adminRoles) => {
  const roleList = adminRoles.join(", ");
  return new Promise((resolve, reject) => {
    confirm({
      content: (
        <div>{`${roleList} ${
          adminRoles.length === 1 ? "is an admin role" : "are admin roles"
        }. Are you sure you want to continue?`}</div>
      ),
      okText: "Yes",
      cancelText: "Cancel",
      icon: null,
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
    });
  });
};
export class HMGRoleMapping extends Component {
  constructor(props) {
    super(props);

    this.state = { ...initialConfigs };
  }

  async componentDidMount() {
    const hmgList = await this.props.hmgmainGetHmgMain();

    this.setState({
      hmgmainList: hmgList,
    });
    if (!this.props.api.rolesGetData) {
      await this.props.rolesGet();
    }
  }

  changeHmgMainSelect = async (e) => {
    const mappedRoles = await this.props.rolesGetMappedtoHMG(e);
    const roles = mappedRoles.map((e) => e._id);
    this.setState({
      hmgmainSelect: e,
      initialValue: roles,
      roleData: Array.isArray(this.props.api.rolesGetData.data)
        ? this.props.api.rolesGetData.data.map((d) => ({
            _id: d._id,
            role_name: d.role_name,
          }))
        : [],
      inactiveSubmit: true,
    });
  };

  updateMappedRoles = (e) => {
    this.setState({ mappedRoles: e, inactiveSubmit: false });
  };

  formFormOneSubmit = async (e) => {
    const returnvalue = await this.props.hmgRoleUpdate({
      hmg_id: this.state.hmgmainSelect,
      role_Ids: this.state.mappedRoles,
      validate_admin_roles:true,
    });
    let confirmReject = false
    if(returnvalue?.error){
      if(returnvalue?.message==="System Manger admin roles assigned" && returnvalue?.data.length>0){
        const returnstatus = await showConfirm(returnvalue?.data);
        if(returnstatus){
          await this.props.hmgRoleUpdate({
            hmg_id: this.state.hmgmainSelect,
            role_Ids: this.state.mappedRoles,
            validate_admin_roles:false,
          });
        }
        confirmReject = !returnstatus;
      }
      else{
        message.error(returnvalue?.message);
      }
    }

    if(!confirmReject){
      const roleData = [...this.state.roleData];
      const hmgmainList = [...this.state.hmgmainList];
      this.setState({
        ...initialConfigs,
        hmgmainList,
        roleData,
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="container_ab">
          <div className="container_style_2 container_style_2_center">
            <HmgMainDropdown
              hmgmainSelect={this.state.hmgmainSelect}
              hmgmainList={this.state.hmgmainList}
              hmgmainChange={this.changeHmgMainSelect}
            />
          </div>
          <HmgRoleMapping
            rolesGetData={this.state.hmgmainSelect?this.state.roleData:[]}
            initialValue={this.state.initialValue}
            updateMappedRoles={this.updateMappedRoles}
            onSubmit={this.formFormOneSubmit}
            activeSubmit={!this.state.inactiveSubmit && this.state.hmgmainSelect}
          />
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
  rolesGet: () => dispatch(rolesGet()),
  rolesGetMappedtoHMG: (data) => dispatch(rolesGetMappedtoHMG(data)),
  hmgRoleUpdate: (data) => dispatch(hmgRoleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HMGRoleMapping);
